import React from 'react';
import { MagneticButton } from '@/components/site/MagneticButton';
import { SITE } from '@/data/site';
import { ArrowUpRight } from 'lucide-react';
import { Reveal } from '@/components/site/Reveal';

export function CTABand({
  eyebrow = 'Got a brief?',
  headline = 'Let’s build the next one together.',
  sub = 'Discovery calls are 30 minutes, free, and on WhatsApp. Bring rough thoughts—we’ll bring sharp questions.',
  className = '',
}) {
  return (
    <section
      data-testid="cta-band"
      className={`relative overflow-hidden border-y border-white/10 bg-ink-surface/40 ${className}`}
    >
      <div className="absolute -left-24 top-1/2 -translate-y-1/2 h-[420px] w-[420px] rounded-full bg-violet/20 blur-[140px] pointer-events-none" />
      <div className="absolute -right-24 -bottom-24 h-[360px] w-[360px] rounded-full bg-electric/15 blur-[140px] pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32 grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
        <Reveal className="md:col-span-7">
          <div className="text-[11px] uppercase tracking-[0.28em] text-ink-muted mb-6">— {eyebrow}</div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] text-balance">
            {headline}
          </h2>
        </Reveal>
        <Reveal className="md:col-span-5 md:pl-6 md:border-l border-white/10" delay={120}>
          <p className="text-ink-muted leading-relaxed mb-8 max-w-md">{sub}</p>
          <div className="flex flex-wrap gap-3">
            <MagneticButton
              href={SITE.whatsapp}
              external
              variant="primary"
              data-testid="cta-band-whatsapp"
            >
              Book discovery call
              <ArrowUpRight size={16} className="-mr-0.5" />
            </MagneticButton>
            <MagneticButton
              href={`mailto:${SITE.email}`}
              variant="ghost"
              data-testid="cta-band-email"
            >
              {SITE.email}
            </MagneticButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
